export default __webpack_public_path__ + "static/media/vector 1.96e1d218.svg";